module.exports = __webpack_public_path__ + "img/bg-plan-item-2.2fc18d94.png";